import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "container", "className", "onOpenAutoFocus"];
import { jsx } from 'react/jsx-runtime';
import * as RadixPopover from '@radix-ui/react-popover';
import clsx from 'clsx';
import { forwardRef, useState, useMemo, useCallback } from 'react';
import { Card } from '../../card/card.js';
import { focusRadioGroupFirstIfExists } from './popover-focus-utils.js';
import { PopoverOverflowContext } from './popover-overflow-context.js';
import styles from './popover.module.js';
/**
 * Based on Radix-UI Popover Content
 * @see https://www.radix-ui.com/primitives/docs/components/popover#content
 */

var PopoverContentContainer = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      container = props.container,
      className = props.className,
      onOpenAutoFocus = props.onOpenAutoFocus,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isContentOverflowing = _useState2[0],
      setIsContentOverflowing = _useState2[1];

  var providerValue = useMemo(function () {
    return {
      isContentOverflowing: isContentOverflowing,
      setIsContentOverflowing: setIsContentOverflowing
    };
  }, [isContentOverflowing, setIsContentOverflowing]); // Workaround for: https://github.com/radix-ui/primitives/issues/1910

  var handleOpenAutoFocus = useCallback(function (e) {
    onOpenAutoFocus === null || onOpenAutoFocus === void 0 ? void 0 : onOpenAutoFocus(e);

    if (e.defaultPrevented) {
      return;
    }

    focusRadioGroupFirstIfExists(e);
  }, [onOpenAutoFocus]);
  return (// TODO(DSYS-440): Unify all Portals (Tooltip, Select, Popover, etc...), Expose a Provider which would tell where to mount (body? other elem?)
    jsx(RadixPopover.Portal, {
      container: container,
      children: jsx(PopoverOverflowContext.Provider, {
        value: providerValue,
        children: jsx(RadixPopover.Content, _objectSpread(_objectSpread({}, rest), {}, {
          ref: forwardedRef,
          className: clsx(styles.popoverContentContainer, className),
          onOpenAutoFocus: handleOpenAutoFocus,
          children: jsx(Card, {
            className: styles.popoverCard,
            children: children
          })
        }))
      })
    })
  );
});
PopoverContentContainer.displayName = 'PopoverContentContainer';
export { PopoverContentContainer };